var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfFileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.969394 0C0.434446 0 0 0.431106 0 0.962889V18.4541C0 18.975 0.431795 19.417 0.964442 19.417H16.5109C17.0434 19.417 17.4753 18.979 17.4753 18.4389L17.475 4.85425L12.621 0H0.969394ZM7.28137 5.33967H9.22307C9.22307 7.75703 11.3042 10.3496 13.8989 11.2146L13.4546 13.0968C10.4108 12.6619 7.26399 13.9612 4.42193 15.856L3.27691 14.29C4.33144 13.4465 5.34252 12.0149 6.09207 10.3428C6.83896 8.67677 7.28137 6.87118 7.28137 5.33967ZM7.86388 11.1372C8.12339 10.5582 8.35348 9.95732 8.54707 9.34783C9.00502 10.0513 9.56801 10.697 10.2038 11.2573C9.25064 11.428 8.31688 11.7081 7.41273 12.0653C7.57263 11.7612 7.72321 11.451 7.86388 11.1372Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFileIcon);
export default __webpack_public_path__ + "static/media/PdfFileIcon.146ce7254f74c96d9c562745eb346063.svg";
export { ForwardRef as ReactComponent };